// extracted by mini-css-extract-plugin
module.exports = {"cookiesSettingWrapper":"settingList_cookiesSettingWrapper__Xm1Sn","title":"settingList_title__9Zoks","status":"settingList_status__HiVAf","content":"settingList_content__hfvzN"};